import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { Solution } from './components/Solution';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Risk } from './components/Risk';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-white font-sans text-ink" data-id="element-0" data-mp="28u5ysp4wd9dw">
      <main data-id="element-1" data-mp="28sl511qepuh3">
        <Hero data-id="element-2" data-mp="28s2xva27hvue" />
        <SocialProof data-id="element-3" data-mp="23vcikoy874a1" />
        <PainPoints data-id="element-4" data-mp="23w4fc33k781w" />
        <Solution data-id="element-5" data-mp="23ujmchww7x65" />
        <Tomos data-id="element-6" data-mp="23v2sl1d6kx4c" />
        <Bonuses data-id="element-7" data-mp="23ti7s3go4sjo" />
        <Risk data-id="element-8" data-mp="3ik7fqfdqo9q4" />
        <Pricing data-id="element-9" data-mp="3ikr002qv3a7b" />
        <Guarantee data-id="element-10" data-mp="3ij652c0mxp8x" />
        <FAQ data-id="element-11" data-mp="3ijpcgysnsv8p" />
        <FinalCTA data-id="element-12" data-mp="3ihuyk4ft23e4" />
      </main>
      <Footer data-id="element-13" data-mp="3ml14faz09sk2" />
      <PurchaseNotifications data-id="element-14" data-mp="3mkrgdsxitvh0" />
    </div>;
}